import { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * AppLayout - Protected layout for all /app/* routes
 * Provides single authentication wall and shared layout
 */
export function AppLayout() {
  const { isSignedIn, isLoaded } = useAuth();

  // Show loading state while checking authentication
  if (!isLoaded) {
    return (
      <div className="min-h-screen bg-brand-parchment dark:bg-neutral-900 flex items-center justify-center">
        <div className="text-center space-y-4">
          <Skeleton className="h-20 w-20 rounded-full mx-auto bg-brand-accent/20" />
          <Skeleton className="h-4 w-48 mx-auto bg-brand-accent/20" />
          <p className="text-sm text-brand-dark/60 dark:text-amber-100/60">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to home if not authenticated
  if (!isSignedIn) {
    return <Navigate to="/" replace />;
  }

  // Render authenticated app layout
  return (
    <div className="bg-brand-parchment dark:bg-neutral-900 text-brand-dark dark:text-amber-50 font-sans min-h-screen flex flex-col transition-colors duration-300">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
